// =============================================================================
// Runs register KPI strip (plan §2D item 2, the part phase 5 skipped).
//
// Four figures above the list, independent of the list's filters: runs
// active right now, and — over runs STARTED in the last seven days — kg
// tipped, kg packed and packout of tipped. Pure arithmetic over one read;
// the page decides (via readState) whether the figures may be stated.
// =============================================================================

export interface KpiRun {
  status:               string
  started_at:           string
  tipped_net_weight_kg: number | null
  intake_kg?:           number | null
  packed_weight_kg:     number | null
  pallet_count:         number | null
}

export interface RunsKpis {
  active:    number
  tippedKg:  number
  packedKg:  number
  pallets:   number
  /** packed ÷ tipped over the window, null when nothing was tipped. */
  ofTipped:  number | null
  /** How many runs started inside the window. */
  runsInWindow: number
}

export const KPI_WINDOW_DAYS = 7

/** ISO instant `days` days before `now` — the read's `started_at >=` bound. */
export function kpiWindowStart(now: Date, days = KPI_WINDOW_DAYS): string {
  const d = new Date(now); d.setDate(d.getDate() - days)
  return d.toISOString()
}

/** The `or=` filter: runs started in the window, plus every ACTIVE run whatever its age. */
export function kpiOrFilter(windowStartIso: string): string {
  return `started_at.gte.${windowStartIso},status.eq.ACTIVE`
}

export function runsKpis(rows: readonly KpiRun[], windowStartIso: string): RunsKpis {
  const inWindow = rows.filter(r => r.started_at >= windowStartIso)
  const tippedKg = inWindow.reduce((s, r) => s + Number(r.tipped_net_weight_kg ?? 0), 0)
  const packedKg = inWindow.reduce((s, r) => s + Number(r.packed_weight_kg ?? 0), 0)
  return {
    active:       rows.filter(r => r.status === 'ACTIVE').length,
    tippedKg,
    packedKg,
    pallets:      inWindow.reduce((s, r) => s + Number(r.pallet_count ?? 0), 0),
    ofTipped:     tippedKg > 0 ? (packedKg / tippedKg) * 100 : null,
    runsInWindow: inWindow.length,
  }
}

export const fmtKg = (kg: number): string => `${Math.round(kg).toLocaleString('en-ZA')} kg`
